import { AfterViewInit, Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { ClockElaboration } from '../../models/clock-elaboration';
import { RestApiService } from '../../services/rest-api.service';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import DataSource from 'devextreme/data/data_source';
import { environment } from '../../../../environments/environment';
import { APIKey, MapMarker } from '../../models/map-marker';
import { Subject, takeUntil } from 'rxjs';
import { formatDate } from '@angular/common';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';



import Map from 'ol/Map';
import View from 'ol/View';
//import TileLayer from 'ol/layer/Tile';
//import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Group from 'ol/layer/Group';
import Overlay from 'ol/Overlay';
import { Style, Icon } from 'ol/style';
import { fromLonLat } from 'ol/proj';

import XYZ from 'ol/source/XYZ';
import { apply } from 'ol-mapbox-style';


interface MarkersInfo {
  lat: number;
  lng: number;
  descr: string;
}



@Component({
    selector: 'app-clock-validation-detail',
    templateUrl: './clock-validation-detail.component.html',
    styleUrls: ['./clock-validation-detail.component.scss'],
    providers: [],
    standalone: false
})
export class ClockValidationDetailComponent implements AfterViewInit {
  @Input() key: number | undefined;
  @Input() rowData: ClockElaboration | undefined;

  private unsubscribe: Subject<void> = new Subject<void>();

  backendURL: string = environment.ApiUrl + '/api';

  tenantId: number;
  errorMessage = "";
  errorVisible = false;
  mapVisible = false;
  clocksDataSource: any;
  isPopupVisible = false;

  lookupData = [
        { id: -1, name: 'Timbratura Precedente' },
        { id: 0, name: 'Timbratura Utilizzata' },
        { id: 1, name: 'Tibratura Successiva' },
        { id: 2, name: 'Tibratura Scartata' },
      ];



   //--- old map --//
  markers: MapMarker[] = [];

  apiKey: APIKey = {
    azure: "ChfbRnQ9Q26640aewm0WMyuswqe74umqdOTQ2LxSQhhd7PEe5hN4JQQJ99BJAC5RqLJ7BGfpAAAgAZMP4egU"
  };
   //-----//


   //  la mappa nuova è da considerarsi di tipo "Terrestre"
  map!: Map;
  private vectorSource!: VectorSource;
  private overlay!: Overlay;
  public locationData: MarkersInfo[] = [];
 


  priorities = [
    'Terrestre',
    'Satellitare',
  ];


  currentPriority: string = this.priorities[0];
  satellitare: boolean = this.currentPriority === 'Satellitare';

  onPriorityChange(e: any): void {
    this.currentPriority = e.value;
    this.updateMapVisibility();
  }

  updateMapVisibility(): void {
    this.satellitare = this.currentPriority === 'Satellitare';
  }



  constructor(@Inject(LOCALE_ID) public locale: string, private restApi: RestApiService) {
    this.tenantId = restApi.readTenantId();

  }

  ngAfterViewInit() {

    this.vectorSource = new VectorSource();

    // carico il
    if (this.rowData && this.rowData.errorMessage) {
      this.errorMessage = this.rowData.errorMessage;
      this.errorVisible = this.rowData.errorMessage != null && (typeof this.rowData.errorMessage === "string" && this.rowData.errorMessage.trim().length !== 0)
    }
    else {
      this.errorMessage = "";
      this.errorVisible = false;
    }

    if (this.key) {

      this.clocksDataSource = new DataSource({
        store: AspNetData.createStore({
          key: 'clockId',
          loadParams: { clockRegistrationId: this.key },
          loadUrl: `${this.backendURL}/ClockElaborations/GetLinks`,
        }),
      });

      this.restApi.getClockMarkers(this.key).pipe(takeUntil(this.unsubscribe)).subscribe((clockMarkers) => {

        this.mapVisible = clockMarkers.length > 0;

        clockMarkers.forEach(clk => {

          if (clk.latitudine && clk.longitudine) {
            const clockDate = clk.deviceDate;
            let direction = clk.direction;
            if (!direction) direction = '';


            //--- old map --//
            const clkMarker = new MapMarker(clk.latitudine, clk.longitudine, 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale));
            this.markers.push(clkMarker);
            //-----//

            this.locationData.push({ lat: clk.latitudine, lng: clk.longitudine, descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale) })

            const feat = new Feature({
              geometry: new Point(fromLonLat([clk.longitudine, clk.latitudine])),
              descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale)
            });
            feat.setStyle(
              new Style({
                image: new Icon({
                  anchor: [0.5, 1],
                  crossOrigin: 'anonymous',
                  src: '/assets/clock-marker.png',
                })
              })
            );
            this.vectorSource.addFeature(feat);

          }

          if (clk.latitudineCantiere && clk.longitudineCantiere && clk.cantiere) {


            //--- old map --//
            const clkCantiereMarker = new MapMarker(clk.latitudineCantiere, clk.longitudineCantiere, clk.cantiere);
            clkCantiereMarker.iconSrc = '/assets/construction-marker.png';
            this.markers.push(clkCantiereMarker);
            //-----//


            const feat = new Feature({
              geometry: new Point(fromLonLat([clk.longitudineCantiere, clk.latitudineCantiere])),
              descr: clk.cantiere
            });
            feat.setStyle(
              new Style({
                image: new Icon({
                  anchor: [0.5, 1],
                  crossOrigin: 'anonymous',
                  src: '/assets/construction-marker.png',
                })
              })
            );
            this.vectorSource.addFeature(feat);

          }




          // popup overlay (cerca gli elementi nel template)
          const container = document.getElementById('popup-' + this.key) as HTMLElement;
          const content = document.getElementById('popup-content-' + this.key) as HTMLElement;
          const closer = document.getElementById('popup-closer-' + this.key) as HTMLElement;

          // per i messaggi popup ? 
          this.overlay = new Overlay({
            element: container!,
            autoPan: { animation: { duration: 250 } }
          });

          // chiudi popup
          if (closer) {
            closer.onclick = () => {
              this.overlay.setPosition(undefined);
              closer.blur();
              return false;
            };
          }

          // resetta la mappa precedente (se presente)
          try {
            if (this.map) {
              this.map.setTarget(undefined);
            }
          } catch { /* ignore */ }

          const openfreemap = new Group();

          // crea la mappa
          this.map = new Map({
            target: 'ol-map-' + this.key,
            layers: [openfreemap],  //[baseLayer, vectorLayer],
            view: new View({
              center: fromLonLat([12.57, 44.06]), // valore temporaneo, verrà adattato
              zoom: 13,
              maxZoom: 22,
            }),
            overlays: [this.overlay]
          });

          // click su mappa: mostra popup se feature sotto il click
          this.map.on('singleclick', (evt) => {
            const feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f);

              
            if (feature) {

              const geometry = feature.getGeometry();
              if (geometry && geometry.getType() === 'Point') {

                //const coords = (feature.getGeometry() as Point).getCoordinates();
                const coords = (geometry as Point).getCoordinates();

                const descr = feature.get('descr') || 'Nessuna descrizione';
                if (content) content.innerHTML = descr;
                this.overlay.setPosition(coords);
              } else {
                this.overlay.setPosition(undefined);
              }
            }
          });


          apply(this.map, 'https://tiles.openfreemap.org/styles/liberty')
            .then(() => {
              const vectorLayer = new VectorLayer({
                source: this.vectorSource,
                // non passare 'map' qui, aggiungilo con addLayer per essere sicuro
              });
              this.map.addLayer(vectorLayer);

              setTimeout(() => {
                this.map.updateSize();

                // fit automatico se ci sono marker
                if (this.vectorSource.getFeatures().length > 0) {
                  const extent = this.vectorSource.getExtent();

                  if (extent) {
                    this.map.getView().fit(extent!, { padding: [50, 50, 50, 50], maxZoom: 25, duration: 800 });
                  }
}
              }, 50);
            })
            .catch(err => {
              console.warn('Errore apply map style:', err);
              // aggiungi comunque vector layer se apply fallisce
              const vectorLayer = new VectorLayer({ source: this.vectorSource });
              this.map.addLayer(vectorLayer);
            });







        });
      });
    }
  }

  togglePopup(): void {
    this.isPopupVisible = !this.isPopupVisible;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  apriMaps(e: DxDataGridTypes.ColumnButtonClickEvent) {
    if (e.row?.data) {
      const url = 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + e.row?.data.latitudine + '%2C' + e.row?.data.longitudine;
      window.open(url, "_blank");
    }
  }
}
